module.exports = __webpack_public_path__ + "media/hd-video.87631c80.mp4";